import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import LoadingOverlay from "../components/features/loading-overlay";

import { scrollTop } from "../utils";

import Layout from "../components/app";
import HomePage from "../components/home";
import Nosidebar from "../components/pages/shop/nosidebar";
import Default from "../components/pages/products/default";
import ErrorPage from "../components/pages/others/404";
import MyAccount from "../components/pages/shop/dashboard";
import Wishlist from "../components/pages/shop/wishlist";
import Cart from "../components/pages/shop/cart";
import Checkout from "../components/pages/shop/checkout";
import AboutOne from "../components/pages/others/about-1";
import ContactOne from "../components/pages/others/contact-1";
import FAQ from "../components/pages/others/faq";
import Login from "../components/pages/others/login";
import PaypalPayment from "../components/Payment/PaypalPayement";
import PaymentSuccess from "../components/Payment/Paymentsucess";
import PaymentFailed from "../components/Payment/Paymentfailed";
import OrderSucessfullPlaced from "../components/pages/shop/OrderSucessfullPlaced";
import ForgetPassword from "../components/pages/others/ForgetPassword";

export default function AppRoot() {
  useEffect(() => {
    scrollTop();
  }, []);

  return (
    <React.Suspense fallback={<LoadingOverlay />}>
      <Layout>
        <Routes>
          <Route exact path="/" element={<HomePage />}></Route>

          {/* Shop Pages */}
          <Route path="/products" element={<Nosidebar />} />
          <Route path="/product/:id" element={<Default />} />
          <Route path="/shop" element={<Nosidebar />} />
          <Route path="/shop/dashboard" element={<MyAccount />} />
          <Route
            path="/shop/dashboard/orders/:orderid"
            element={<MyAccount />}
          />
          <Route path="/shop/wishlist" element={<Wishlist />} />
          <Route path="/shop/cart" element={<Cart />} />
          <Route path="/shop/checkout" element={<Checkout />} />

          {/* Others Pages */}
          <Route path="/pages/404" element={<ErrorPage />} />
          <Route path="/about" element={<AboutOne />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<ContactOne />} />
          <Route path="/login" element={<Login />} />
          <Route path="/resetPassword" element={<ForgetPassword />} />


          {/* Order Processing */}
          <Route path="/OrderSuccess" element={<OrderSucessfullPlaced />} />
          <Route
            path="/payments/paypal/process/:orderId"
            element={<PaypalPayment />}
          />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-failed" element={<PaymentFailed />} />
          <Route path="/payment-cancelled" element={<PaymentFailed />} />

          {/* Catch-all route for invalid routes */}
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </Layout>
    </React.Suspense>
  );
}
